import { render, staticRenderFns } from "./RecognitionChallengesConfig.vue?vue&type=template&id=5dcee5f3&scoped=true&"
import script from "./RecognitionChallengesConfig.vue?vue&type=script&lang=js&"
export * from "./RecognitionChallengesConfig.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionChallengesConfig.vue?vue&type=style&index=0&id=5dcee5f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcee5f3",
  null
  
)

export default component.exports